import { Col, Form, message, Row } from "antd";
import { routes } from "common/routes";
import { AppPageHeader } from "components/AppPageHeader";
import { StoreConfigForm } from "forms/StoreConfigForm";
import { useAppDispatch } from "hooks/useAppDispatch";
import { useAppSelector } from "hooks/useAppSelector";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { createStoreConfig } from "store/ppd/ppdSlice";
import { getDarkStores, getCities } from "store/admin-slice/adminServicesSlice";

const MESSAGE_KEY = "new-store-config";

const NewStoreConfigPage = () => {
  const [form] = Form.useForm();
  const dispatch = useAppDispatch();
  const { status, error } = useAppSelector((state) => state.ppd);
  const { darkStores, cities } = useAppSelector((state) => state.adminServices);
  const navigate = useNavigate();

  const [cityId, setCityId] = useState<string>();
  const [storeId, setStoreId] = useState<string>();

  useEffect(() => {
    dispatch(getDarkStores());
    dispatch(getCities());
  }, [dispatch]);

  useEffect(() => {
    if (status === "saving") {
      message.loading({ content: "Creating store configuration...", key: MESSAGE_KEY });
    } else if (status === "success") {
      message.success({ content: "Store configuration created successfully!", key: MESSAGE_KEY, duration: 2 });
    } else if (status === "error") {
      message.error({ content: error, key: MESSAGE_KEY, duration: 3 });
    }

    return () => message.destroy();
  }, [status, error]);

  const onSubmit = () => {
    form.submit();
  };

  const onCancel = () => {
    if (window.history.state && window.history.state.idx > 0) {
      navigate(-1);
    } else {
      navigate(`/${routes.PPD.STORE_CONFIGS}`);
    }
  };

  const onFinish = (values: Record<string, any>) => {
    const formValues = {
      ...values,
      storeId: parseInt(values.storeId),
      // Format time values to HH:mm:ss string
      pickPackStartTime: values.pickPackStartTime?.format("HH:mm:ss"),
      dispatchStartTime: values.dispatchStartTime?.format("HH:mm:ss"),
    };

    dispatch(createStoreConfig(formValues as any))
      .unwrap()
      .then(() => {
        setTimeout(() => {
          navigate(`/${routes.PPD.STORE_CONFIGS}`);
        }, 1000);
      })
      .catch((err) => {
        console.error("Failed to create store config:", err);
      });
  };

  const handleCityChange = (selectedCityId: string) => {
    setCityId(selectedCityId);
    setStoreId(undefined);
    form.setFieldsValue({ storeId: undefined });
  };

  const handleStoreChange = (selectedStoreId: string) => {
    setStoreId(selectedStoreId);
  };

  return (
    <>
      <Row>
        <Col>
          <AppPageHeader title="New Store Configuration" />
        </Col>
      </Row>
      <Row>
        <Col xs={24} lg={18} xl={16}>
          <StoreConfigForm
            formInstance={form}
            onCancel={onCancel}
            onFinish={onFinish}
            onSubmit={onSubmit}
            loading={status === "saving"}
            showStoreSelection={true}
            cities={cities}
            darkStores={darkStores}
            selectedCityId={cityId}
            selectedStoreId={storeId}
            onCityChange={handleCityChange}
            onStoreChange={handleStoreChange}
          />
        </Col>
      </Row>
    </>
  );
};

export default NewStoreConfigPage;
